export default "__VITE_ASSET__B_wnoo3D__"